import React from "react";
import { LeftOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useHistory } from 'react-router';
import { GenerateLogo } from "../logoHelpers";
import GoogleTranslator from "../GoogleTranslator";
import { useSelector } from "react-redux";

function RestaurantHeader(props) {
  const history = useHistory();
  const verticalId = useSelector(state => state.companyConfig.vertical_id);
  const wrapperClass = verticalId === 3 ?
                       "restaurant-logo-wrapper"
                       : "business-logo-wrapper";

  return (
    <div className="restaurant-header-wrapper">
      <span className="back-button">
        <Button type="default" onClick={() => history.push('/public/welcome/form')}><LeftOutlined /></Button>
      </span>
      <div className={wrapperClass} >
        <GenerateLogo className="restaurant-logo" />
      </div>
      <div className="restaurant-translation">
        <GoogleTranslator />
      </div>
    </div>
  );
}

export default RestaurantHeader;
